// removed by extract-text-webpack-plugin
module.exports = {"button":"button___3_Ozh","primary":"primary___zYyzg","secondary":"secondary___3Hm6m","small":"small___nAPfO","tertiary":"tertiary___1vMCD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.scss
// module id = wyFM
// module chunks = 46